import { render, staticRenderFns } from "./DriverContractForVehicleWidget.vue?vue&type=template&id=556a161e&scoped=true&"
import script from "./DriverContractForVehicleWidget.vue?vue&type=script&lang=js&"
export * from "./DriverContractForVehicleWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverContractForVehicleWidget.vue?vue&type=style&index=0&id=556a161e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a161e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556a161e')) {
      api.createRecord('556a161e', component.options)
    } else {
      api.reload('556a161e', component.options)
    }
    module.hot.accept("./DriverContractForVehicleWidget.vue?vue&type=template&id=556a161e&scoped=true&", function () {
      api.rerender('556a161e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverContractForVehicleWidget.vue"
export default component.exports